import './Merchandising.scss';
import Component from './Merchandising.js';
export default Component;